import React, { useEffect, useState, useCallback } from "react";
import { Button, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { removeAllProducts } from "../../redux/actions/cart";
import { makePayment } from "../../redux/actions/payment";
import {
  getCheckoutState,
  removeCheckoutState,
  setCheckoutState,
} from "../../redux/actions/checkout";
import { getCosts } from "../../redux/actions/payment";
import { body } from "../../commons/functions/orderObjectFormat";
import { getSubtotalFromCart } from "../../commons/functions/generalFunctions";
import Lottie from "react-lottie";
import success from "../../lotties/success.json";
import warning from "../../lotties/warning.json";
import error from "../../lotties/error.json";
import "./styles.css";

const getSubTotal = ({ currencySelect, cart }) => {
  let subtotal = 0;
  if (currencySelect && !currencySelect.loading) {
    subtotal = parseFloat(
      getSubtotalFromCart(
        cart,
        currencySelect.currency.currency === "USD" ? "USD" : "HNL",
        currencySelect.currency.currencyLayer
          ? currencySelect.currency.currencyLayer.data.value
          : 0
      )
    );
  }
  return subtotal;
};

const getTotal = ({
  shippingCost,
  currencySelect,
  applyShippingCost,
  discount,
  customizationCost,
  cart,
}) => {
  let total = 0;
  if (currencySelect && !currencySelect.loading) {
    if (applyShippingCost) {
      if (currencySelect.currency.currency === "USD") {
        total = (
          Math.round(
            (getSubTotal({ currencySelect, cart }) +
              getSubTotal({ currencySelect, cart }) * discount +
              customizationCost +
              shippingCost / currencySelect.currency.currencyLayer.data.value) *
              100
          ) / 100
        ).toFixed(2);
      } else {
        total = (
          Math.round(
            (getSubTotal({ currencySelect, cart }) +
              getSubTotal({ currencySelect, cart }) * discount +
              customizationCost +
              shippingCost) *
              100
          ) / 100
        ).toFixed(2);
      }
    } else {
      total =
        getSubTotal({ currencySelect, cart }) +
        getSubTotal({ currencySelect, cart }) * discount +
        customizationCost;
    }
  }
  return parseFloat(total);
};

const ResponseAction = ({
  location,
  history,
  removeAllProducts,
  makePayment,
  checkout,
  getCheckoutState,
  setCheckoutState,
  removeCheckoutState,
  cart,
  shippingCost,
  getCosts,
  payment,
}) => {
  const result = location.pathname.split("/")[3];
  const order = location.pathname.split("/")[4];
  const origin = location.pathname.split("/")[5];

  const [orderNumber, setOrderNumber] = useState("false");
  const [loading, setLoading] = useState(true);
  const [myBody, setMyBody] = useState({ value: null });
  const [helper, setHelper] = useState({ value: "first", error: "" });
  const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if (result === "1") {
      getCheckoutState();
      getCosts();
    } else {
      getCheckoutState();
    }
  }, [result, getCheckoutState, getCosts]);

  const clear = useCallback(() => {
    if (
      result !== "1" &&
      !checkout.loading &&
      checkout.data.orderInfo &&
      checkout.data.orderInfo.orderNumber &&
      helper.value === "first"
    ) {
      helper.value = "second";
      setHelper({ value: "second", error: "" });
      setCheckoutState({ ...checkout.data, orderInfo: { orderNumber: "" } });
    }
  }, [checkout, result, helper, setCheckoutState]);

  useEffect(() => {
    if (!checkout.loading && !payment.loading) {
      if (
        result === "1" &&
        checkout.data.orderInfo &&
        checkout.data.orderInfo.orderNumber &&
        order === checkout.data.orderInfo.orderNumber
      ) {
        if (
          checkout.data.orderInfo &&
          checkout.data.orderInfo.orderNumber !== "false"
        ) {
          setOrderNumber(checkout.data.orderInfo.orderNumber);
        }
        if (orderNumber !== "false") {
          const {
            currencySelect,
            discount,
            customizationCost,
            applyShippingCost,
          } = checkout.data;
          const subtotal = getSubTotal({ currencySelect, cart });
          const total = getTotal({
            shippingCost,
            currencySelect,
            applyShippingCost,
            discount,
            customizationCost,
            cart,
          });
          setMyBody({
            value: body({
              ...checkout.data,
              subtotal,
              total,
              cart,
              shippingCost,
            }),
          });
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } else {
      if (checkout.data.orderInfo && !checkout.data.orderInfo.orderNumber) {
        history.push("/checkout/result/0/");
      } else {
        clear();
      }
      setLoading(false);
    }
  }, [
    cart,
    checkout,
    shippingCost,
    result,
    orderNumber,
    order,
    payment,
    history,
    clear,
  ]);

  const pay = useCallback(() => {
    if (myBody.value) {
      if (origin === "amx") makePayment(myBody.value);
      setMyBody({ value: null });
    }
  }, [myBody, origin, makePayment]);

  useEffect(() => {
    if (myBody.value) {
      removeAllProducts();
      removeCheckoutState();
      pay();
    }
  }, [myBody, removeAllProducts, removeCheckoutState, pay]);

  const retryPurchase = () => {
    history.push("/checkout");
  };

  const keepBuying = () => {
    history.push("/products/Todos");
  };

  const termsAndConditions = () => {
    history.push("/purchases");
  };

  return (
    <div className="ra-container">
      {loading ? (
        <div className="loader-container">
          <Loader
            style={{ alignSelf: "center" }}
            size="large"
            inline="centered"
            active
          />
        </div>
      ) : (
        <div className="ra-error-container">
          <Lottie
            options={{
              ...defaultOptions,
              animationData:
                result === "1" ? success : result === "0" ? warning : error,
            }}
            height={100}
            width={100}
          />
          <h2 className="ra-headers">
            {result === "1"
              ? "Orden realizada con éxito"
              : result === "0"
              ? "Esta página está protegida"
              : "Error al procesar su orden"}
          </h2>
          <p className="ra-headers">
            {result === "1"
              ? "En breve recibirá un correo electrónico con los detalles de la compra."
              : result === "0"
              ? "Para mayor información póngase en contacto con La Floristería Honduras"
              : "Para mayor información póngase en contacto con el banco emisor de su tarjeta o revise los datos de la misma."}
          </p>
          {result === "1" ? (
            <Button primary onClick={keepBuying}>
              Seguir comprando
            </Button>
          ) : result === "0" ? (
            <Button secondary onClick={termsAndConditions}>
              Términos y Condiciones
            </Button>
          ) : (
            <Button secondary onClick={retryPurchase}>
              Inténtelo de nuevo
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ checkout, cart, payment }) => ({
  shippingCost: checkout.data.shippingCost,
  payment,
  checkout,
  cart: cart.cart,
});

export default connect(mapStateToProps, {
  removeAllProducts,
  makePayment,
  getCheckoutState,
  getCosts,
  removeCheckoutState,
  setCheckoutState,
})(ResponseAction);
